import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_BASE_URL+"/api/v1/task-templates",
  headers: {
    "Content-Type": "application/json",
  },
});

export const createTaskTemplate = async (payload) => {
  const { data } = await api.post("/add", payload);
  return data;
};

export const updateTaskTemplate = async (payload) => {
  const { data } = await api.post("/update", payload);
  return data;
};

export const updateTaskTemplateStatus = async (payload) => {
  const { data } = await api.post("/update/status", payload);
  return data;
};

export const getTaskTemplate = async (templateId) => {
  const { data } = await api.post("/get", { templateId });
  return data;
};

export const getAllTaskTemplates = async ({ activeOnly } = {}) => {
  const { data } = await api.post("", {
    activeOnly,
  });
  return data;
};

export const deleteTaskTemplate = async (templateId) => {
  const { data } = await api.post("/delete", {
    data: { templateId },
  });
  return data;
};